import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { Fade } from "react-reveal";
import "./PersianLime.css";
import { t } from "i18next";

function PersianLime(props) {
  const theme = props.theme;

  return (
    <div className="privacy-main">
      <Header theme={theme} setTheme={props.setTheme} />
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="privacy-heading-div">
            <div className="privacy-heading-text-div">
              <h1
                className="privacy-heading-text"
                style={{ color: theme.text }}
              >
                {t("titles.PERSIAN LIME")}
              </h1>
            </div>
          </div>
        </Fade>
        <div>
          <div className="skills-main-div">
            <Fade left duration={2000}>
              <div className="skills-image-div">
                <img
                  src={require(`../../assests/images/sangabriel/limon-persa-1.jpg`)}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    boxSizing: "border-box",
                    marginTop: "10%",
                  }}
                  alt="Lemon"
                  fill={theme.accentColor}
                />
              </div>
            </Fade>

            <div className="skills-text-div">
              <Fade right duration={2000}>
                <div>
                  <p
                    className="subTitle skills-text"
                    style={{ color: theme.secondaryText }}
                  >
                    {t("sections.persian-lime")}
                  </p>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </div>
      <Footer theme={props.theme} onToggle={props.onToggle} />
    </div>
  );
}

export default PersianLime;
